import { invokeApi } from "../../bl_libs/invokeApi";

export const students_all_reports_list_api = async (data, signal = null) => {
  const requestObj = {
    path: `api/associates/students_all_reports_list`,
    method: "POST",
    postData: data,
    signal,
  };
  return invokeApi(requestObj);
};

export const add_student_report_api = async (data) => {
  const requestObj = {
    path: `api/student_reports`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_student_report_api = async (data, student_report_id) => {
  const requestObj = {
    path: `api/student_reports/${student_report_id}`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_student_report_api = async (student_report_id) => {
  const requestObj = {
    path: `api/student_reports/${student_report_id}`,
    method: "DELETE",
  };
  return invokeApi(requestObj);
};
